export function processValuesForDraft(values, fields) {
  return Object.values(fields).reduce((acc, field) => {
    if (field.processValueForDraft) {
      acc[field.name] = field.processValueForDraft(values[field.name]);
    }
    return acc;
  }, values);
}
